import { render } from "./CompleteRegister.vue?vue&type=template&id=49c0adf0"
import script from "./CompleteRegister.vue?vue&type=script&lang=js"
export * from "./CompleteRegister.vue?vue&type=script&lang=js"

import "./CompleteRegister.vue?vue&type=style&index=0&id=49c0adf0&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__